import React from 'react';
// components
import Form from '../../../components/Form/Form';
import { Link } from 'react-router-dom';
import FieldError from '../../../components/Form/FieldError';
import Input from '../../../components/Input/Input';
import PasswordInput from '../../../components/PasswordInput/PasswordInput';
import Button from '../../../components/Button/Button';
import CheckBox from '../../../components/CheckBox/CheckBox';
// utils
import { withFormik } from 'formik';
import * as yup from 'yup';
import { responseErrors } from '../../../utils/response';
import validations from '../../../utils/validations';
// styles
import cn from 'classnames/bind';
import styles from '../SignUp.mod.css';

const cx = cn.bind(styles);

export const SignUpForm = ({
  values,
  touched,
  errors = {},
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  status = {},
  className = '',
  compact,
  title,
}) => (
  <Form
    className={cx('signUpForm', className, { compact })}
    onSubmit={handleSubmit}
  >
    <h2 className={styles.title}>{title || 'Sign Up'}</h2>
    <div className="form-control">
      <div className="field-wrapper">
        <Input
          id="email"
          placeholder="Email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={errors.email && touched.email}
        />
        <FieldError error={errors.email} touched={touched.email} />
      </div>
    </div>
    <div className="form-control">
      <div className="field-wrapper">
        <PasswordInput
          id="password"
          isToggeled
          placeholder="Password"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={errors.password && touched.password}
        />
        <FieldError error={errors.password} touched={touched.password} />
      </div>
    </div>
    <div className="form-control">
      <div className="field-wrapper">
        <PasswordInput
          id="passwordConfirm"
          isToggeled
          placeholder="Repeat Password"
          value={values.passwordConfirm}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={errors.passwordConfirm && touched.passwordConfirm}
        />
        <FieldError
          error={errors.passwordConfirm}
          touched={touched.passwordConfirm}
        />
      </div>
    </div>
    <CheckBox
      label={
        <span className={cx('terms')}>
          I agree to{' '}
          <Link className={cx('link')} to="/terms" target="_blank">
            Terms & Conditions
          </Link>
        </span>
      }
      name="terms"
      checked={values.terms}
      onChange={handleChange}
      onBlur={handleBlur}
      invalid={errors.terms && touched.terms}
    />
    <div className={styles.buttons}>
      <Button
        type="submit"
        primary
        isLoading={isSubmitting}
        disabled={isSubmitting || !values.terms}
      >
        Sign up
      </Button>
      <Link className={styles.link} to="/login">
        Log in
      </Link>
    </div>
  </Form>
);

export default withFormik({
  mapPropsToValues: ({ support }) => ({
    email: support || '',
    password: '',
    passwordConfirm: '',
    terms: false,
  }),
  validateOnBlur: false,
  validateOnChange: false,
  validationSchema: yup.object().shape({
    email: yup
      .string()
      .email('Invalid email address')
      .required('Email is required!'),
    password: validations.password,
    passwordConfirm: yup
      .string()
      .oneOf([yup.ref('password'), null], "Passwords don't match")
      .required('Password confirm is required!'),
  }),
  handleSubmit: (
    { email, password, passwordConfirm },
    { setSubmitting, setStatus, setErrors, props: { onSubmit, support } }
  ) => {
    onSubmit({
      role: support ? 'support' : 'client',
      confirm_success_url: window.location.origin + '/signup/confirmation',
      email,
      password,
      passwordConfirm,
    })
      .then(() => {
        setSubmitting(false);
        setStatus({ submitted: true });
      })
      .catch(response => {
        setErrors(responseErrors(response));
        setSubmitting(false);
      });
  },
  displayName: 'SignUpForm',
})(SignUpForm);



// WEBPACK FOOTER //
// ./src/containers/SignUp/components/SignUpForm.jsx